import type { PureQueryOptions } from '@apollo/client';
import { faUpload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { PictureInitialParentType } from '~/apollo/generated/v4/graphql';
import { Modal } from '~/components/common/Modal';
import { Button } from '~/components/ui/button';
import { PictureUploadV4 } from '~/components/upload/file/picture-upload-v4';
import { useModalState } from '~/hooks/modal';

export function UploadPicturesModal({
  parentType,
  parentId,
  disabled,
  refetchQueries,
}: {
  parentType: PictureInitialParentType;
  parentId: number;
  disabled?: boolean;
  refetchQueries: PureQueryOptions[];
}) {
  const { show, showModal, hideModal } = useModalState();

  return (
    <>
      <Button
        type="button"
        color="primary"
        size="xs"
        onClick={showModal}
        disabled={disabled}
        className="inline-block space-x-1"
      >
        <FontAwesomeIcon icon={faUpload} /> Upload Pictures
      </Button>

      <Modal open={show} onHide={hideModal} size="lg">
        <Modal.Body heading="Upload Pictures">
          <PictureUploadV4
            parentType={parentType}
            parentId={parentId}
            refetchQueries={refetchQueries}
          />
        </Modal.Body>
      </Modal>
    </>
  );
}
